import { extractSnapshotOptions } from '../../../lib/snapshot-search';
import { cellDataKeys, ensureFlatOpts } from '../../analysis/trend-evaluator';

export const getSortKey = (row: any, activeSubTab: string): number => {
    switch (activeSubTab) {
        case 'Combined OI': return row.combOI || 0;
        case 'Combined Volume': return row.combVol || 0;
        case 'Top OI': return row.oi || 0;
        case 'Top Volume': return row.volume || 0;
        case 'Top Chng OI': return Math.abs(row.oiChg || 0);
        default: return row.volume || 0;
    }
};

export const getConnectingDotsRows = (snap: any, symbol: string, expiry: string, atmStrike: number, activeRange: number, gap: number) => {
    const rawOpts = extractSnapshotOptions(snap, symbol, expiry);
    if (!rawOpts || rawOpts.length === 0) return { itmRows: [], otmRows: [] };

    const minStrike = atmStrike - activeRange * gap;
    const maxStrike = atmStrike + activeRange * gap;

    const flatOpts = ensureFlatOpts(rawOpts);
    
    const allRows = flatOpts.filter((o: any) => o.strike >= minStrike && o.strike <= maxStrike);

    const itmRows = allRows.filter((r: any) => 
        (r.type === 'CE' ? r.strike <= atmStrike : r.strike >= atmStrike)
    );
    const otmRows = allRows.filter((r: any) => 
        (r.type === 'CE' ? r.strike > atmStrike : r.strike < atmStrike)
    );

    return { itmRows, otmRows };
};

export const getSupportResistance = (chain: any[], atmStrike: number, activeRange: number, gap: number, settingsMode: string) => {
    const minStrike = atmStrike - activeRange * gap;
    const maxStrike = atmStrike + activeRange * gap;

    const flatOpts = ensureFlatOpts(chain);
    const validRows = flatOpts.filter((r: any) => r.strike >= minStrike && r.strike <= maxStrike);

    const valKey = cellDataKeys[settingsMode] || 'oi';

    // Map rows based on settingsMode metric
    const ceRows = validRows
        .filter((r: any) => r.type === 'CE')
        .map((r: any) => ({
            strike: r.strike,
            val: r[valKey] || 0
        }))
        .sort((a: any, b: any) => b.val - a.val)
        .slice(0, 3);

    const peRows = validRows
        .filter((r: any) => r.type === 'PE')
        .map((r: any) => ({
            strike: r.strike,
            val: r[valKey] || 0
        }))
        .sort((a: any, b: any) => b.val - a.val)
        .slice(0, 3);

    // Resistance: min of top 3 CE
    const resistanceStrike = ceRows.length > 0 ? Math.min(...ceRows.map((r: any) => r.strike)) : 0;
    
    // Support: max of top 3 PE
    const supportStrike = peRows.length > 0 ? Math.max(...peRows.map((r: any) => r.strike)) : 0;

    return { supportStrike, resistanceStrike };
};
